<script lang="ts" setup>
import { FormElementBase } from "~/api";

const props = defineProps<{
  /** Form elements available to select. */
  options: FormElementBase[];
  multiple?: boolean;
}>();

const selectedFormElementGuids = defineModel<string | string[] | undefined>({
  required: true,
});
</script>

<template>
  <div class="formElementSelect">
    <el-select
      v-model="selectedFormElementGuids"
      size="small"
      placeholder="Form Item"
      clearable
      style="max-width: 180px"
      :multiple="multiple"
      filterable
    >
      <el-option
        v-for="formElement in options"
        :key="formElement.questionCode"
        :label="formElement.questionCode"
        :value="formElement.guid"
      >
      </el-option>
    </el-select>
  </div>
</template>

<style lang="less" scoped>
.formElementSelect {
}
</style>
